export default __webpack_public_path__ + "static/media/FoodWeb_01.44f524d5.png";